// Dark theme colors (current default)
export const darkColors = {
  brand: '#ea7211', // Webvonk accent (--brand)
  background: '#000000', // Dark background
  surface: '#0d0d0d', // Card/surface background
  text: '#ffffff', // Main text color
  muted: 'rgba(255, 255, 255, 0.7)', // Muted text
  border: '#222222', // Border color
  white: '#ffffff', // White color
  
  // Status colors
  success: '#16a34a',
  error: '#dc2626',
  warning: '#f59e0b',
  info: '#2563eb',
  
  // Background variations
  lightGray: '#111111',
  mediumGray: '#1a1a1a',
};

// Light theme colors
export const lightColors = {
  brand: '#ea7211', // Webvonk accent (--brand)
  background: '#ffffff', // White background
  surface: '#f8f9fa', // Card/surface background
  text: '#222222', // Main text color
  muted: '#6b7280', // Muted text
  border: '#e5e7eb', // Border color
  white: '#ffffff', // White color
  
  // Status colors
  success: '#16a34a',
  error: '#dc2626',
  warning: '#f59e0b',
  info: '#2563eb',
  
  // Background variations
  lightGray: '#f8f9fa',
  mediumGray: '#f3f4f6',
};

// Default to dark colors for backward compatibility
export const colors = darkColors;

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '32px',
  xxxl: '48px',
  xxxxl: '64px',
  xxxxxl: '80px',
};

export const borderRadius = {
  sm: '6px',
  md: '8px',
  lg: '12px',
  xl: '16px',
};

export const fontSize = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  xxl: '24px',
  xxxl: '32px',
};

export const fontWeight = {
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
};

export const shadows = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

// Theme helper functions
export const getThemeColors = (themeMode) => {
  switch (themeMode) {
    case 'light':
      return lightColors;
    case 'dark':
    default:
      return darkColors;
  }
};

// Export theme object for styled-components ThemeProvider
export const theme = {
  colors,
  spacing,
  borderRadius,
  fontSize,
  fontWeight,
  shadows,
};
